import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styleUrls: ['./pagenotfound.component.scss'],
    standalone: false
})
export class PagenotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.href = environment.SSO.redirect_uri;
  }

}
